<ng-container *ngIf="jobs.length > 0 && !!jobs">
  <h3>Verwendet in folgenden Jobs:</h3>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'job_id'">Jobnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Jobname</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_date'">Jobdatum</clr-dg-column>
    <clr-dg-column [clrDgField]="'delivery_date'" [clrDgSortOrder]="descSort">Lieferdatum</clr-dg-column>
    <clr-dg-placeholder>Keinen dazugehörigen Job gefunden!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let job of jobs" [routerLink]="['/job/details', job.project_id, job.job_id]">
      <clr-dg-cell>{{ job.project_id }}.0006.{{ job.job_id }}</clr-dg-cell>
      <clr-dg-cell>{{ job.company_name }}</clr-dg-cell>
      <clr-dg-cell>{{ job.name_project }}</clr-dg-cell>
      <clr-dg-cell>{{ job.status }}</clr-dg-cell>
      <clr-dg-cell>{{ job.job_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ job.delivery_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{jobs.length}} Job(s)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</ng-container>
